export const promiseTraverse = async <T, B>(
  array: T[],
  mapFct: (item: T) => Promise<B>
): Promise<B[]> => {
  const results: B[] = [];
  for (let i = 0; i < array.length; i++) {
    const item = array[i];
    const result = await mapFct(item);
    results.push(result);
  }
  return results;
};
